var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatappLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12c0 2.15.617 4.151 1.738 5.866L2 22l4.296-1.372A9.936 9.936 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.948 7.948 0 01-4.228-1.216l-.303-.193-2.55.814.847-2.474-.194-.305A7.948 7.948 0 014 12c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8zm3.707-5.56c-.196-.099-1.157-.572-1.337-.638-.18-.067-.31-.099-.44.099-.13.197-.502.638-.616.77-.115.132-.23.148-.426.05-.196-.099-.827-.303-1.574-.966-.581-.52-.974-1.162-1.089-1.358-.115-.196-.012-.302.086-.398.088-.087.197-.23.295-.345.1-.115.13-.197.197-.328.066-.132.033-.247-.017-.345-.05-.099-.44-1.064-.603-1.456-.159-.385-.32-.334-.44-.34-.12-.005-.259-.007-.398-.007s-.365.053-.556.25c-.191.197-.725.71-.725 1.73s.743 2.007.846 2.143c.104.132 1.459 2.228 3.538 3.122.493.214.877.342 1.177.438.495.157.946.135 1.3.081.397-.06 1.157-.473 1.32-.929.163-.456.163-.847.115-.928-.05-.08-.178-.132-.373-.231z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatappLogo);
export default __webpack_public_path__ + "static/media/whatapp-logo.374c856670e9ae97fba173b11dea8bea.svg";
export { ForwardRef as ReactComponent };